module.exports = __webpack_public_path__ + "img/dingdanquxiao.19c5f0cc.png";